import React from 'react';
import { toast } from 'react-toastify';

import { Bloc } from '@mairistem/administres-utils';
import { request } from '@mairistem/tools';
import { BlocTile } from '@/components/Common';
import useEntiteStore from '@/zustand/useEntiteStore';
import TYPES_ACTES from '@/constants/typesActes';

import PacsModal from '../Modals/ActeModal';

interface BlocSynthetiqueProps {
  style?: React.CSSProperties;
  setLoading: (loading: boolean) => void;
}

type SelectedTypeActe =
  | 'naissance'
  | 'reconnaissance'
  | 'mariage'
  | 'deces'
  | 'decision'
  | 'pacs'
  | 'mention';

const MODAL_TITLE_BY_TYPE_ACTE: Record<SelectedTypeActe, string> = {
  naissance: 'Liste des actes de naissances',
  reconnaissance: 'Liste des actes de reconnaissances',
  mariage: 'Liste des actes de mariages',
  deces: 'Liste des actes de décès',
  pacs: 'Liste des pacs',
  decision: 'Liste des décisions',
  mention: 'Liste des mentions',
};

const BlocSynthetique = (props: BlocSynthetiqueProps) => {
  const { style, setLoading } = props;

  const [statsSynthese, setStatsSynthese] = React.useState<any>(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedType, setSelectedType] = React.useState<
    SelectedTypeActe | undefined
  >(undefined);
  const blocked = useEntiteStore((state) => state.blocked);

  React.useEffect(() => {
    if (!blocked) {
      setLoading(true);
      request
        .get('/api/administres/etat-civil/numerisation-actes/synthese')
        .then((data) => {
          setStatsSynthese(data);
        })
        .catch(() => {
          toast.error(
            'Une erreur est survenue lors de la récupération de la synthèse',
          );
        })
        .finally(() => setLoading(false));
    }
  }, [blocked, setLoading]);

  return (
    <Bloc
      icon="file text"
      header={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div>Vue synthétique</div>
        </div>
      }
      style={style}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          gap: '1em',
          marginTop: '1.5em',
          flexWrap: 'wrap',
        }}
      >
        {TYPES_ACTES.slice(0, 4).map((type) => (
          <BlocTile
            key={type.key}
            title={type.text}
            stats={
              statsSynthese
                ? statsSynthese[
                    type.key.endsWith('s') ? type.key : `${type.key}s`
                  ]
                : '0'
            }
            statsColor={type.statsColor}
            textColor={type.textColor}
            onClick={() => {
              setSelectedType(type.key as typeof selectedType);
              setOpenModal(true);
            }}
            icon={type.icon}
          />
        ))}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          gap: '1em',
          marginTop: '1em',
        }}
      >
        {TYPES_ACTES.slice(4).map((type) => (
          <BlocTile
            key={type.key}
            title={type.text}
            stats={
              statsSynthese
                ? statsSynthese[
                    type.key.endsWith('s') ? type.key : `${type.key}s`
                  ]
                : '0'
            }
            statsColor={type.statsColor}
            textColor={type.textColor}
            onClick={
              type.key === 'mention'
                ? undefined
                : () => {
                    setSelectedType(type.key as typeof selectedType);
                    setOpenModal(true);
                  }
            }
            icon={type.icon}
          />
        ))}
      </div>
      <PacsModal
        open={openModal}
        title={selectedType ? MODAL_TITLE_BY_TYPE_ACTE[selectedType] : ''}
        typeActe={selectedType}
        onClose={() => {
          setOpenModal(false);
          setSelectedType(undefined);
        }}
      />
    </Bloc>
  );
};

export default BlocSynthetique;
